
const mutations = {
  PSE_STATUS (state, data) {
    state.pseStatus = data
  },
  PAYMENT_LINK_STATUS(state, data) {
    state.paymentLinkStatus = data
  },
  TEMPORAL_COUPON (state, data) {
    state.temporalCoupon = data
  },
  PSE_ORDER (state, data) {
    state.pseOrder = data
  }
}

export default mutations
